const env = {
  production: process.env.NODE_ENV === 'production',
  development: process.env.NODE_ENV === 'development',
  iPhone: /iphone/i.test(navigator.userAgent)
}

if (env.iPhone) {
  document.querySelector('body').classList.add('device-iphone');
}

export default env;



/** WEBPACK FOOTER **
 ** ./src/env.js
 **/